/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { hideVideoDebugOverlay } from '../../videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import {
    onKeyLeftActionsStrip,
    onKeyOkActionsStrip,
    onKeyRightActionsStrip,
} from './actionsstripnavigation.reducers';
import { setIsFullInfoActive, setIsStandardInfoActive } from './infobanner.actions';
import { hideFullInfo, updateFullInfoBannerTimer } from './infobanner.reducers';

export const onKeyBackFullInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { isVideoDebugOverlayActive } = getState().videoDebugOverlay;
    if (isVideoDebugOverlayActive) {
        dispatch(hideVideoDebugOverlay());
    }
    dispatch(hideFullInfo());
};

export const onKeyLeftFullInfoBanner = () => (dispatch: Function) => {
    dispatch(setIsFullInfoActive(false));
    dispatch(setIsStandardInfoActive(false));
    dispatch(onKeyLeftActionsStrip());
    dispatch(updateFullInfoBannerTimer());
};

export const onKeyOkFullInfoBanner = () => (dispatch: Function) => {
    dispatch(onKeyOkActionsStrip());
};

export const onKeyRightFullInfoBanner = () => (dispatch: Function) => {
    dispatch(onKeyRightActionsStrip());
    dispatch(setIsStandardInfoActive(false));
    dispatch(setIsFullInfoActive(false));
    dispatch(updateFullInfoBannerTimer());
};

export const onKeyChannelDownFullInfoBanner = () => (dispatch: Function) => {
    dispatch(setIsStandardInfoActive(true));
    dispatch(setIsFullInfoActive(true));
    dispatch(updateFullInfoBannerTimer());
};

export const onKeyDownFullInfoBanner = () => (dispatch: Function) => {
    dispatch(updateFullInfoBannerTimer());
};

export const onKeyChannelUpFullInfoBanner = () => (dispatch: Function) => {
    dispatch(setIsStandardInfoActive(true));
    dispatch(setIsFullInfoActive(true));
    dispatch(updateFullInfoBannerTimer());
};

export const onMouseClickRightFullInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { actionsStripHighlightIndex, actionItemsCount } = getState().infoBanner;
    if (actionItemsCount > 1 && actionItemsCount !== actionsStripHighlightIndex + 1)
        dispatch(onKeyRightFullInfoBanner());
};

export const onMouseClickLeftFullInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { actionsStripHighlightIndex } = getState().infoBanner;
    if (actionsStripHighlightIndex) dispatch(onKeyLeftFullInfoBanner());
};
